import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Divider,
  Button,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import Logo from "../../assets/images/logo.png";
import { API_URL, backend } from "../../config";
import ContactInfo from "./ContactInfo";

const VerifyEmail = (props) => {
  const [status, setStatus] = useState("pending"); // pending, verifying, success, error
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });

  const logout = () => {
    localStorage.removeItem("user");
    window.location = "/";
  };

  useEffect(() => {
    const verifyEmail = async () => {
      setStatus("verifying");
      try {
        const response = await backend.get(`${API_URL}verify/${uid}/${token}`);

        if (response.status === 200) {
          setStatus("success");

          const userSession = JSON.parse(localStorage.getItem("user"));

          if (
            Boolean(response?.data?.redirect) ||
            (userSession?.user &&
              userSession.user.needs_email_verified === false)
          ) {
            window.location = "/";
          }

          if (userSession?.user) {
            const userSessionNew = { ...userSession };
            userSessionNew.user.needs_email_verified = false;
            localStorage.setItem("user", JSON.stringify(userSessionNew));
          } else {
            logout();
          }
        }
      } catch (error) {
        setStatus("error");
        setErrorInfo({
          error: true,
          message:
            error.response?.data?.message ||
            "An error occurred during verification.",
        });
      }
    };

    const pathParts = window.location.pathname.split("/");
    const pathIncludesVerify = pathParts.includes("verify");
    const uid = pathParts?.[2];
    const token = pathParts?.[3];

    if (pathIncludesVerify && uid && token) {
      setStatus("verifying");
      verifyEmail();
    }
  }, []);

  return (
    <Box
      position="relative"
      width="100%"
      maxWidth={400}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <img
        src={Logo}
        alt="logo"
        height="80"
        style={{ position: "absolute", top: -110, opacity: 0.9 }}
      />
      <Paper
        elevation={3}
        sx={{ p: 4, textAlign: "center", width: "100%", borderRadius: 2 }}
      >
        {status === "pending" && (
          <>
            <ErrorIcon color="warning" sx={{ fontSize: 64, mb: 1 }} />
            <Typography variant="h6" fontWeight="bold" color="warning.main">
              Email verification required. Please check your email.
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Verify your email and refresh this page
            </Typography>
          </>
        )}

        {status === "verifying" && (
          <>
            <CircularProgress size={48} sx={{ mb: 2 }} />
            <Typography variant="h6" fontWeight="bold">
              Verifying your email...
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Please wait a moment.
            </Typography>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 1 }} />
            <Typography variant="h6" fontWeight="bold" color="success.main">
              Email Verified
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Refresh the page and you can now access the app. Welcome aboard!
            </Typography>
          </>
        )}

        {status === "error" && (
          <>
            <ErrorIcon color="error" sx={{ fontSize: 64, mb: 1 }} />
            <Typography variant="h6" fontWeight="bold" color="error.main">
              Verification Failed
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              The link might be invalid or expired. Please contact us.
              <br />
              {errorInfo.error && `Error: ${errorInfo.message}`}
            </Typography>
          </>
        )}
      </Paper>
      <ContactInfo />
      <Divider sx={{ mt: 1 }} />
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        <Button
          color="primary"
          size="small"
          onClick={logout}
          sx={{ textTransform: "none", p: 0, minWidth: "auto" }}
        >
          Logout
        </Button>
      </Typography>
    </Box>
  );
};

export default VerifyEmail;
